import $ from 'jquery';
import Cookies from 'js-cookie';
import regions from '../../config/regions';
import getParameterByName from '../../../../../@infinite/scripts/core/INF-getParameterByName';
import checkDomain from './checkDomain';
import countryRedirect from './countryRedirect';
import preventFutureModals from './preventFutureModals';

export default() => {
  // If the regions object is empty, disable this component
  if ($.isEmptyObject(regions)) { return; }

  // Disable redirects for preview links
  const preview_key = getParameterByName('preview_key'); 
  const isShopifyPreview = (window.location.href.indexOf('shopifypreview') !== -1);
  
  if (preview_key && preview_key.length > 0) {
    console.log('skipping redirect for preview_key', preview_key);
    return;
  }

  if (isShopifyPreview) {
    console.log('skipping redirect because of preview');
    return;
  }

  // Easy reset of cookies for dev
  if (getParameterByName('reset_region')) {
    Cookies.remove('country');
    Cookies.remove('region_ignore');
  }

  // If we're forcing a region on page load, set the cookie immediately
  if (getParameterByName('country')) {
    Cookies.set('country', getParameterByName('country'), { expires: 365, path: '/' });
  } 

  // 1 ms timeout to ensure cookie has time to be set above, if necessary
  setTimeout(() => {
    if (Cookies.get('country')) {
      return checkDomain(Cookies.get('country'));
    }

    return $.get('https://geoip.lfshopify.com/', (response) => {
      checkDomain(response.country_code);
    });
  }, 1);

  // Changing Region via the menu
  $('[data-region-selector-item]').click((e) => {
    countryRedirect($(e.currentTarget).data('country'));
  });

  // $('[data-region-redirect-button]').click((e) => {
  //   $(e.currentTarget).text('Redirecting...');
  // });

  preventFutureModals();
};
